export default "<div class=\"arrow-tooltip\">\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</div>\n"